import React from 'react'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { List, Map } from 'immutable'
import Button, { TYPES } from '../../Button/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { JOIN_NOW_URL, JOIN_NOW_QUERY } from '../../../services/live-access-events/constants'
import { TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM } from '../../../services/dialog/index'
import { PLAN_SKU_INCREASED_PRICE_GAIA_PLUS } from '../../../services/plans/index'
import { useGetPlanDataBySku } from '../../../services/plans/hooks'
import { get as getConfig } from '../../../config/index'
import { getBoundActions } from '../../../actions/index'

const config = getConfig()
const planGraphQLActive = !!config.features?.checkout?.planGraphQL

const ChatCTA = (props) => {
  const {
    subscriptions,
    staticText,
    joinChatText,
    setPlanChangeSelected,
    renderModal,
    userAccount,
    auth,
    language,
  } = props

  const isEntitled = subscriptions && subscriptions.size
  const buttonText = staticText.getIn(['data', isEntitled ? 'upgradeNow' : 'joinNow']) || ''

  // Get Gaia+ plan data for upgrade
  const userPlanSku = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'planSku'])
  const gqlPlanData = useGetPlanDataBySku({
    userLanguage: language,
    authJwt: auth.get('jwt'),
    planSkus: PLAN_SKU_INCREASED_PRICE_GAIA_PLUS,
  }) || Map()
  const gaiaPlusPlan = gqlPlanData.get('plans', List()).first()
  const gaiaPlusPlanComplete = gqlPlanData.get('complete', false)

  // Get current user plan data
  const gqlUserPlanData = useGetPlanDataBySku({
    userLanguage: language,
    authJwt: auth.get('jwt'),
    planSkus: userPlanSku,
    forceRefresh: true,
  }) || Map()
  const userPlanComplete = gqlUserPlanData.get('complete', false)
  const userPlanData = gqlUserPlanData.get('plans', List()) || List()
  const currentPlan = userPlanData.get(0) || Map()

  const onClickAccountChangePlan = (plan, userCurrentPlan) => {
    setPlanChangeSelected(plan)
    renderModal(TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM, {
      hideDismiss: false,
      ...(planGraphQLActive && { currentPlan: userCurrentPlan }),
    })
  }

  const handleUpgradeClick = () => {
    // Try to proceed even if plan data isn't fully loaded
    if (gaiaPlusPlanComplete && userPlanComplete) {
      onClickAccountChangePlan(gaiaPlusPlan, currentPlan)
    } else if (gaiaPlusPlan && gaiaPlusPlan.size > 0) {
      onClickAccountChangePlan(gaiaPlusPlan, currentPlan)
    }
  }

  return (
    <div className="chat__anonCTA">
      {joinChatText || staticText.getIn(['data', 'joinChat'])}
      <Button
        type={TYPES.PRIMARY}
        url={!isEntitled ? JOIN_NOW_URL : null}
        query={!isEntitled ? JOIN_NOW_QUERY : null}
        onClick={isEntitled ? handleUpgradeClick : null}
      >
        {buttonText}
      </Button>
    </div>
  )
}

export default compose(
  connectRedux(
    (state) => {
      return {
        subscriptions: state.auth.get('subscriptions'),
        userAccount: state.userAccount,
        auth: state.auth,
        language: state.user.getIn(['data', 'language', 0], 'en'),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setPlanChangeSelected: actions.plans.setPlanChangeSelected,
        renderModal: actions.dialog.renderModal,
      }
    },
  ),
  connectStaticText({ storeKey: 'eventsPage' }),
)(ChatCTA)
